"use strict";

;
(function (SidebarNav, $) {
  var sidebarDisplay = function sidebarDisplay() {
    if ($('.sidebar-nav__container').length) {
      var nearEndOfPage = checkPageOffset();
      var stickyNavHeight = $('.site-header-sticky').height();
      var offset = $('.sidebar-nav__container').offset();
      var staticHeight = $('.static-about-nav').height();
      var atBreakpoint = offset.top + staticHeight - window.pageYOffset <= stickyNavHeight;
      if (nearEndOfPage) {
        hideFixedBar();
      } else {
        atBreakpoint ? showFixedBar() : hideFixedBar();
      }
    }
  };
  var showCurrentSection = function showCurrentSection() {
    if ($('.block-content').length) {
      var $data = $('.current-sidebar-section');
      var $currentNumber = $data.find('.section-number');
      var $currentHeading = $data.find('.section-heading');
      var staticOffset = $('.static-about-nav').offset().left;
      var number = 1;
      var offsets = [];

      // SET LEFT ABSOLUTE POSITION FOR FIXED NAV
      $('.fixed-about-nav').css({
        "left": staticOffset + "px"
      });
      $('.block-content').each(function () {
        var top = $(this).offset().top - 150;
        offsets.push(top);
        if (window.pageYOffset > top) {
          number = $(this).data('number');
        }
      });
      var title = $('.block-content').eq(number - 1).data('title');
      $currentHeading.text(title);
      $currentNumber.text(number);
      offsets.map(function (offset) {
        if (offset === window.pageYOffset && offset !== offsets[0]) {
          number += 1;
        }
      });
      $('.all-sections-container .page-section').removeClass('active');
      $(".all-sections-container .page-section-".concat(number)).addClass('active');
    }
  };
  var showFixedBar = function showFixedBar() {
    var $fixedBar = $('.fixed-about-nav');
    var height = $('.site-header-sticky').height();
    if (!$fixedBar.hasClass('active')) {
      $fixedBar.addClass('active').slideDown(500).css({
        "top": height
      });
    }
  };
  var hideFixedBar = function hideFixedBar() {
    var $fixedBar = $('.fixed-about-nav');
    $fixedBar.hide().removeClass('active');
  };
  var closeDropdown = function closeDropdown() {
    $('.all-sections-container').hide();
    $('.current-sidebar-section .icon-right-arrow').removeClass('active');
  };
  var checkPageOffset = function checkPageOffset() {
    var $firstElement = '';
    var $lastElement = '';
    if ($('.hero').length) {
      $firstElement = $('.hero');
    }
    if ($('.related-content').length) {
      $lastElement = $('.related-content');
    } else if ($('.similar-posts-section').length) {
      $lastElement = $('.similar-posts-section');
    } else if ($('.related-content-section').length) {
      $lastElement = $('.related-content-section');
    } else {
      $lastElement = $('#shopify-section-footer');
    }

    // HIDE FIXED BAR IF NEAR THE TOP ELEMENT OF PAGE
    var firstOffset = $firstElement.offset();
    var nearHeader = firstOffset.top - window.pageYOffset >= -800 && window.innerWidth >= 1024;

    // HIDE FIXED BAR IF NEAR THE BOTTOM ELEMENT OF PAGE
    var lastOffset = $lastElement.offset();
    var nearFooter = lastOffset.top - window.pageYOffset <= 750 && window.innerWidth >= 1024;
    if (nearFooter || nearHeader) {
      return true;
    }
    return false;
  };
  var displayActiveSection = function displayActiveSection() {
    var reference = window.location.href.replace(/(.*\/blogs\/)|(.*\/pages\/)/g, '');
    $('.static-about-nav .section-content a').each(function () {
      var url = $(this).attr('href').replace(/(.*\/blogs\/)|(.*\/pages\/)/g, '');
      var number = $(this).data('number');
      var title = $(".all-sections-container .page-section-".concat(number)).data('title');
      if (reference === url) {
        // RESET STATE
        $('.all-sections-container .page-section').removeClass('active');

        // UPDATE CURRENT STATE
        $(".all-sections-container .page-section-".concat(number)).addClass('active');
        $('.current-sidebar-section .section-number').text(number);
        $('.current-sidebar-section .section-heading').text(title);
        return;
      }
    });
  };
  var goToSection = function goToSection(number) {
    var section = ".block-content[data-number=\"".concat(number, "\"]");
    if (window.innerWidth <= 1023) {
      // MOBILE TO TABLET
      $('html, body').animate({
        scrollTop: $(section).offset().top - 100
      }, 0);
    } else {
      // DESKTOP
      $('html, body').animate({
        scrollTop: $(section).offset().top + 30
      }, 0);
    }
  };
  var eventHandlers = function eventHandlers(page) {
    // HIDE / SHOW FIXED SIDEBAR ON MOBILE
    $(window).on('scroll', function () {
      if ($('.sidebar-nav__container').length) {
        showCurrentSection();
      }
    });

    // OPEN / CLOSE DROPDOWN
    $('.current-sidebar-section').on('click', function () {
      $(this).closest('.sidebar__nav').find('.all-sections-container').slideToggle(500).closest('.sidebar__nav').find('.icon-right-arrow').toggleClass('active');
    });

    // AFTER SELECTION, CLOSE DROP-DOWN ON MOBILE
    $('.all-sections-container .page-section').on('click', function (e) {
      e.preventDefault();
      var number = $(this).data('topic');

      // IF NOT ON ABOUT PAGE,
      // REDIRECT TO ABOUT PAGE
      if (page !== 'about') {
        window.location.href = '/pages/about?' + number;
      }

      // SCROLL TO PAGE SECTION
      goToSection(number);
      if (window.innerWidth <= 1023) {
        closeDropdown();
      }
    });
  };
  SidebarNav.init = function (page) {
    eventHandlers(page);
    showCurrentSection();
    if (page === 'about') {
      setInterval(function () {
        sidebarDisplay();
      }, 100);
    }
    if (page !== 'about') {
      displayActiveSection();
    } else if (page === 'about') {
      var hasParams = /(\?)|([0-9])/g;
      if (window.location.href.match(hasParams)) {
        var url = window.location.href.split('?');
        var number = url[1];
        goToSection(number);
      }
    }
  };
})(window.SidebarNav = window.SidebarNav || {}, jQuery, undefined);